/**
 * #context_action.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Empty } from "../../../google/protobuf/empty.js";
import { messageTypeRegistry } from "../../../typeRegistry.js";
import { RedditObject, SubredditObject } from "../../plugin/redditapi/common/common_msg.js";
import { Effect } from "../../ui/effects/v1alpha/effect.js";
import { ConfigForm } from "../user_configurable/user_configurable.js";
import { contextTypeFromJSON, contextTypeToJSON } from "./context_type.js";
function createBaseContextActionAllowedContexts() {
    return { post: false, comment: false, subreddit: false };
}
export const ContextActionAllowedContexts = {
    $type: "devvit.actor.reddit.ContextActionAllowedContexts",
    encode(message, writer = _m0.Writer.create()) {
        if (message.post !== false) {
            writer.uint32(8).bool(message.post);
        }
        if (message.comment !== false) {
            writer.uint32(16).bool(message.comment);
        }
        if (message.subreddit !== false) {
            writer.uint32(24).bool(message.subreddit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContextActionAllowedContexts();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.post = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.comment = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.subreddit = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            post: isSet(object.post) ? globalThis.Boolean(object.post) : false,
            comment: isSet(object.comment) ? globalThis.Boolean(object.comment) : false,
            subreddit: isSet(object.subreddit) ? globalThis.Boolean(object.subreddit) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.post !== false) {
            obj.post = message.post;
        }
        if (message.comment !== false) {
            obj.comment = message.comment;
        }
        if (message.subreddit !== false) {
            obj.subreddit = message.subreddit;
        }
        return obj;
    },
    create(base) {
        return ContextActionAllowedContexts.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseContextActionAllowedContexts();
        message.post = object.post ?? false;
        message.comment = object.comment ?? false;
        message.subreddit = object.subreddit ?? false;
        return message;
    },
};
messageTypeRegistry.set(ContextActionAllowedContexts.$type, ContextActionAllowedContexts);
function createBaseContextActionAllowedUsers() {
    return { moderator: false, member: false, loggedOut: false };
}
export const ContextActionAllowedUsers = {
    $type: "devvit.actor.reddit.ContextActionAllowedUsers",
    encode(message, writer = _m0.Writer.create()) {
        if (message.moderator !== false) {
            writer.uint32(8).bool(message.moderator);
        }
        if (message.member !== false) {
            writer.uint32(16).bool(message.member);
        }
        if (message.loggedOut !== false) {
            writer.uint32(24).bool(message.loggedOut);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContextActionAllowedUsers();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.moderator = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.member = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.loggedOut = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            moderator: isSet(object.moderator) ? globalThis.Boolean(object.moderator) : false,
            member: isSet(object.member) ? globalThis.Boolean(object.member) : false,
            loggedOut: isSet(object.loggedOut) ? globalThis.Boolean(object.loggedOut) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.moderator !== false) {
            obj.moderator = message.moderator;
        }
        if (message.member !== false) {
            obj.member = message.member;
        }
        if (message.loggedOut !== false) {
            obj.loggedOut = message.loggedOut;
        }
        return obj;
    },
    create(base) {
        return ContextActionAllowedUsers.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseContextActionAllowedUsers();
        message.moderator = object.moderator ?? false;
        message.member = object.member ?? false;
        message.loggedOut = object.loggedOut ?? false;
        return message;
    },
};
messageTypeRegistry.set(ContextActionAllowedUsers.$type, ContextActionAllowedUsers);
function createBaseContextActionPostFilters() {
    return { currentApp: undefined };
}
export const ContextActionPostFilters = {
    $type: "devvit.actor.reddit.ContextActionPostFilters",
    encode(message, writer = _m0.Writer.create()) {
        if (message.currentApp !== undefined) {
            writer.uint32(8).bool(message.currentApp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContextActionPostFilters();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.currentApp = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { currentApp: isSet(object.currentApp) ? globalThis.Boolean(object.currentApp) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.currentApp !== undefined) {
            obj.currentApp = message.currentApp;
        }
        return obj;
    },
    create(base) {
        return ContextActionPostFilters.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseContextActionPostFilters();
        message.currentApp = object.currentApp ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(ContextActionPostFilters.$type, ContextActionPostFilters);
function createBaseContextActionDescription() {
    return {
        actionId: "",
        name: "",
        description: "",
        contexts: undefined,
        users: undefined,
        userInput: undefined,
        postFilters: undefined,
    };
}
export const ContextActionDescription = {
    $type: "devvit.actor.reddit.ContextActionDescription",
    encode(message, writer = _m0.Writer.create()) {
        if (message.actionId !== "") {
            writer.uint32(10).string(message.actionId);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.description !== "") {
            writer.uint32(26).string(message.description);
        }
        if (message.contexts !== undefined) {
            ContextActionAllowedContexts.encode(message.contexts, writer.uint32(34).fork()).ldelim();
        }
        if (message.users !== undefined) {
            ContextActionAllowedUsers.encode(message.users, writer.uint32(42).fork()).ldelim();
        }
        if (message.userInput !== undefined) {
            ConfigForm.encode(message.userInput, writer.uint32(50).fork()).ldelim();
        }
        if (message.postFilters !== undefined) {
            ContextActionPostFilters.encode(message.postFilters, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContextActionDescription();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.actionId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.contexts = ContextActionAllowedContexts.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.users = ContextActionAllowedUsers.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.userInput = ConfigForm.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.postFilters = ContextActionPostFilters.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            actionId: isSet(object.actionId) ? globalThis.String(object.actionId) : "",
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            contexts: isSet(object.contexts) ? ContextActionAllowedContexts.fromJSON(object.contexts) : undefined,
            users: isSet(object.users) ? ContextActionAllowedUsers.fromJSON(object.users) : undefined,
            userInput: isSet(object.userInput) ? ConfigForm.fromJSON(object.userInput) : undefined,
            postFilters: isSet(object.postFilters) ? ContextActionPostFilters.fromJSON(object.postFilters) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.actionId !== "") {
            obj.actionId = message.actionId;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.contexts !== undefined) {
            obj.contexts = ContextActionAllowedContexts.toJSON(message.contexts);
        }
        if (message.users !== undefined) {
            obj.users = ContextActionAllowedUsers.toJSON(message.users);
        }
        if (message.userInput !== undefined) {
            obj.userInput = ConfigForm.toJSON(message.userInput);
        }
        if (message.postFilters !== undefined) {
            obj.postFilters = ContextActionPostFilters.toJSON(message.postFilters);
        }
        return obj;
    },
    create(base) {
        return ContextActionDescription.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseContextActionDescription();
        message.actionId = object.actionId ?? "";
        message.name = object.name ?? "";
        message.description = object.description ?? "";
        message.contexts = (object.contexts !== undefined && object.contexts !== null)
            ? ContextActionAllowedContexts.fromPartial(object.contexts)
            : undefined;
        message.users = (object.users !== undefined && object.users !== null)
            ? ContextActionAllowedUsers.fromPartial(object.users)
            : undefined;
        message.userInput = (object.userInput !== undefined && object.userInput !== null)
            ? ConfigForm.fromPartial(object.userInput)
            : undefined;
        message.postFilters = (object.postFilters !== undefined && object.postFilters !== null)
            ? ContextActionPostFilters.fromPartial(object.postFilters)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(ContextActionDescription.$type, ContextActionDescription);
function createBaseContextActionList() {
    return { actions: [] };
}
export const ContextActionList = {
    $type: "devvit.actor.reddit.ContextActionList",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.actions) {
            ContextActionDescription.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContextActionList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.actions.push(ContextActionDescription.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            actions: globalThis.Array.isArray(object?.actions)
                ? object.actions.map((e) => ContextActionDescription.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.actions?.length) {
            obj.actions = message.actions.map((e) => ContextActionDescription.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return ContextActionList.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseContextActionList();
        message.actions = object.actions?.map((e) => ContextActionDescription.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(ContextActionList.$type, ContextActionList);
function createBaseContextActionRequest() {
    return { actionId: "", context: 0, post: undefined, comment: undefined, subreddit: undefined, userInput: undefined };
}
export const ContextActionRequest = {
    $type: "devvit.actor.reddit.ContextActionRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.actionId !== "") {
            writer.uint32(10).string(message.actionId);
        }
        if (message.context !== 0) {
            writer.uint32(16).int32(message.context);
        }
        if (message.post !== undefined) {
            RedditObject.encode(message.post, writer.uint32(26).fork()).ldelim();
        }
        if (message.comment !== undefined) {
            RedditObject.encode(message.comment, writer.uint32(34).fork()).ldelim();
        }
        if (message.subreddit !== undefined) {
            SubredditObject.encode(message.subreddit, writer.uint32(42).fork()).ldelim();
        }
        if (message.userInput !== undefined) {
            ConfigForm.encode(message.userInput, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContextActionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.actionId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.context = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.post = RedditObject.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.comment = RedditObject.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.subreddit = SubredditObject.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.userInput = ConfigForm.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            actionId: isSet(object.actionId) ? globalThis.String(object.actionId) : "",
            context: isSet(object.context) ? contextTypeFromJSON(object.context) : 0,
            post: isSet(object.post) ? RedditObject.fromJSON(object.post) : undefined,
            comment: isSet(object.comment) ? RedditObject.fromJSON(object.comment) : undefined,
            subreddit: isSet(object.subreddit) ? SubredditObject.fromJSON(object.subreddit) : undefined,
            userInput: isSet(object.userInput) ? ConfigForm.fromJSON(object.userInput) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.actionId !== "") {
            obj.actionId = message.actionId;
        }
        if (message.context !== 0) {
            obj.context = contextTypeToJSON(message.context);
        }
        if (message.post !== undefined) {
            obj.post = RedditObject.toJSON(message.post);
        }
        if (message.comment !== undefined) {
            obj.comment = RedditObject.toJSON(message.comment);
        }
        if (message.subreddit !== undefined) {
            obj.subreddit = SubredditObject.toJSON(message.subreddit);
        }
        if (message.userInput !== undefined) {
            obj.userInput = ConfigForm.toJSON(message.userInput);
        }
        return obj;
    },
    create(base) {
        return ContextActionRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseContextActionRequest();
        message.actionId = object.actionId ?? "";
        message.context = object.context ?? 0;
        message.post = (object.post !== undefined && object.post !== null)
            ? RedditObject.fromPartial(object.post)
            : undefined;
        message.comment = (object.comment !== undefined && object.comment !== null)
            ? RedditObject.fromPartial(object.comment)
            : undefined;
        message.subreddit = (object.subreddit !== undefined && object.subreddit !== null)
            ? SubredditObject.fromPartial(object.subreddit)
            : undefined;
        message.userInput = (object.userInput !== undefined && object.userInput !== null)
            ? ConfigForm.fromPartial(object.userInput)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(ContextActionRequest.$type, ContextActionRequest);
function createBaseContextActionResponse() {
    return { success: false, message: "", effects: [] };
}
export const ContextActionResponse = {
    $type: "devvit.actor.reddit.ContextActionResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.success !== false) {
            writer.uint32(8).bool(message.success);
        }
        if (message.message !== "") {
            writer.uint32(18).string(message.message);
        }
        for (const v of message.effects) {
            Effect.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContextActionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.success = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.effects.push(Effect.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
            message: isSet(object.message) ? globalThis.String(object.message) : "",
            effects: globalThis.Array.isArray(object?.effects) ? object.effects.map((e) => Effect.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.success !== false) {
            obj.success = message.success;
        }
        if (message.message !== "") {
            obj.message = message.message;
        }
        if (message.effects?.length) {
            obj.effects = message.effects.map((e) => Effect.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return ContextActionResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseContextActionResponse();
        message.success = object.success ?? false;
        message.message = object.message ?? "";
        message.effects = object.effects?.map((e) => Effect.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(ContextActionResponse.$type, ContextActionResponse);
export const ContextActionServiceName = "devvit.actor.reddit.ContextAction";
export class ContextActionClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || ContextActionServiceName;
        this.rpc = rpc;
        this.GetActions = this.GetActions.bind(this);
        this.OnAction = this.OnAction.bind(this);
    }
    GetActions(request, metadata) {
        const data = Empty.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetActions", data, metadata);
        return promise.then((data) => ContextActionList.decode(_m0.Reader.create(data)));
    }
    OnAction(request, metadata) {
        const data = ContextActionRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "OnAction", data, metadata);
        return promise.then((data) => ContextActionResponse.decode(_m0.Reader.create(data)));
    }
}
export const ContextActionDefinition = {
    name: "ContextAction",
    fullName: "devvit.actor.reddit.ContextAction",
    methods: {
        getActions: {
            name: "GetActions",
            requestType: Empty,
            requestStream: false,
            responseType: ContextActionList,
            responseStream: false,
            options: {},
        },
        onAction: {
            name: "OnAction",
            requestType: ContextActionRequest,
            requestStream: false,
            responseType: ContextActionResponse,
            responseStream: false,
            options: {},
        },
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
